import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/da0rmcuth95mubjtuj60";

type Status = "idle" | "loading" | "success" | "error";

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测：若有填写则伪装成成功，阻止机器人
    const honeypot = String(fd.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢订阅！我们会不定期分享同人志内容精选。");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
      const spamHit = /spam/i.test(serverMsg) || /spam/i.test(responseText);

      if (res.ok && parsed?.code === "OK" && !spamHit) {
        setStatus("success");
        setMessage("感谢订阅！我们会不定期分享同人志内容精选。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg && serverMsg.trim() ? serverMsg : "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  }

  return (
    <form
      id="newsletter-form"
      data-readdy-form="newsletter-form"
      onSubmit={handleSubmit}
      className="mt-6 flex w-full max-w-md flex-col gap-3 sm:flex-row sm:gap-2"
    >
      <label htmlFor="nl-email" className="sr-only">
        电子邮箱
      </label>
      <input
        id="nl-email"
        name="email"
        type="email"
        required
        placeholder="输入你的邮箱，订阅内容更新"
        className="w-full rounded-full border border-background-300 bg-background-50 px-5 py-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
      />
      <input
        name="company_alt"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-honeypot"
      />
      <button
        type="submit"
        disabled={status === "loading"}
        className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:opacity-60"
      >
        {status === "loading" ? "提交中…" : "订阅"}
      </button>
      {status === "success" && (
        <p className="mt-2 text-sm text-primary-700 sm:col-span-2">{message}</p>
      )}
      {status === "error" && (
        <p className="mt-2 text-sm text-primary-800">{message}</p>
      )}
    </form>
  );
}